import { useEffect, useState } from 'react';
import useRedeemTokenApi from './api';
import useApi from '../../../utils/api';

const useRedeemToken = () => {
  const { authGet } = useApi();
  const {
    t,
    user,

    loadedGamesData,
    gamesData,

    loadedWalletData,
    walletData,

    fetchRedeemData,

    handleRedeemCoinPackSubmit,
  } = useRedeemTokenApi();

  return {
    t,
    user,

    loadedGamesData,
    gamesData,

    loadedWalletData,
    walletData,

    fetchRedeemData,

    handleRedeemCoinPackSubmit,
  };
};

export default useRedeemToken;
